// extracted by mini-css-extract-plugin
export default {"root":"style_root__shXcf","logo":"style_logo__A-uPC","description":"style_description__wKR1G"};